class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.patchAccountTriggerLinks();
    this.addEventListener('click', this.onAccountTriggerClick);

    const swiperEl = this.querySelector('swiper-container');
    if (!swiperEl) return;

    customElements.whenDefined('swiper-container').then(() => {
      swiperEl.initialize();

      const domSlideCount = swiperEl.querySelectorAll('swiper-slide').length;
      if (swiperEl.swiper && swiperEl.swiper.slides.length !== domSlideCount) {
        swiperEl.swiper.update();
      }

      // Loop mode clones slides, so re-patch links on the duplicates
      this.patchAccountTriggerLinks();
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onAccountTriggerClick);
  }

  patchAccountTriggerLinks() {
    this.querySelectorAll('[data-account-trigger] a').forEach(link => {
      link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  onAccountTriggerClick = e => {
    const link = e.target.closest('a');
    const trigger = link?.closest('[data-account-trigger]');
    if (!trigger) return;

    const accountId = document.querySelector('[data-modal-content^="account-drawer-"]')?.dataset.modalContent;
    if (!accountId) return;

    e.preventDefault();
    window.dispatchEvent(new CustomEvent('modal:openById', { detail: accountId }));

    const section = trigger.dataset.accountSection;
    if (section) {
      setTimeout(() => document.querySelector(`[data-account-target="${section}"]`)?.click(), 0);
    }
  };
}

customElements.define('announcement-bar', AnnouncementBar);
